var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datas)?_c('div',[_c('Wp_jd_getlink',{attrs:{"url":_vm.datas.url,"height":_vm.screenHeight + 'px'}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }